import { FC } from 'react';
import styled from 'styled-components';

import { gettext } from '@cranium/i18n';
import logo from './Sidebar/Logo.svg';

type PoweredProps = {
  className?: string;
};

const Powered: FC<PoweredProps> = props => {
  return (
    <Column {...props}>
      <StyledText>{gettext('Powered by')}</StyledText>
      <Logo src={logo} />
    </Column>
  );
};

const Logo = styled.img`
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
`;

const StyledPowered = styled(Powered)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 72px;
`;

const StyledText = styled.span`
  color: var(--gray-10);
  font: var(--font-regular-10);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export default StyledPowered;
